import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import PropTypes from 'prop-types';

const ElectionsWidget = ({ widgets }) => {
  const [type, setType] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      const pathParts = window.location.pathname.split('/');
      const typeFromUrl = pathParts[pathParts.indexOf('elections') + 1];
      setType(typeFromUrl);
    }
  }, []);
  const currentWidget = get(widgets, type, null);

  useEffect(() => {
    if (currentWidget?.type === 'jsembed' && currentWidget?.script) {
      if (!document.querySelector(`script[src="${currentWidget.script}"]`)) {
        const script = document.createElement('script');
        script.src = currentWidget.script;
        script.async = true;
        script.setAttribute('data-theme', 'light');
        script.setAttribute('data-force-theme', 'light');
        document.body.appendChild(script);
      }
    }
  }, [currentWidget?.type, currentWidget?.script]);

  return (
    <div
      style={{
        ...(currentWidget?.widget_style || {}),
      }}
    >
      {currentWidget?.type === 'jsembed' ? (
        <div
          className={currentWidget?.widget || '__dtype'}
          data-mb={currentWidget?.datamb}
          {...(currentWidget?.dataAttributes && typeof currentWidget.dataAttributes === 'object'
            ? currentWidget.dataAttributes
            : {})}
          style={{
            ...(currentWidget?.mobile_style || {}),
          }}
        ></div>
      ) : (
        <iframe
          src={currentWidget?.src}
          frameBorder="0"
          scrolling="no"
          width={currentWidget?.width}
          height={currentWidget?.height}
          title="top-widget-iframe"
        ></iframe>
      )}
    </div>
  );
};

ElectionsWidget.propTypes = {
  widgets: PropTypes.object,
};

const mapStateToProps = (state) => ({
  widgets: get(state, ['qt', 'config', 'features', 'state_elections'], {}),
});

export default connect(mapStateToProps)(ElectionsWidget);
